import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-channel-push",
  "use": "foquz-icon-channel-push-usage",
  "viewBox": "0 0 18 19",
  "content": "<symbol viewBox=\"0 0 18 19\" fill=\"none\" id=\"foquz-icon-channel-push\"><path d=\"M10.538 17a1.778 1.778 0 01-3.076 0m6.871-10.667a5.333 5.333 0 10-10.666 0c0 6.223-2.667 8-2.667 8h16s-2.667-1.777-2.667-8z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol